import React from 'react';
import { titleCase } from '@ls/js-utils';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_DEFINITION } from './actions';
import { selectDefinitions, selectFetchingSecurityAttributesData } from 'state/securityAttributes/selectors';
import SelectionState from 'state/selections/SelectionState';

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetching = useSelector(selectFetchingSecurityAttributesData);
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.map(definition => {
      const {attribute, key} = definition;
      return {
        headerName: `${titleCase(attribute)}`,
        field: key,
        colId: key,
        loading: fetching,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      };
    }, []);
  }, [dispatch, definitions, fetching]);
}